import { UIText1 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import { getAmenityIcon } from './amenityIcons';
import * as style from './style.css';
import { IFeatureItem as IFeaturesItemProps } from '../../../types/offerData';

export const FeaturesItem: React.FC<React.PropsWithChildren<IFeaturesItemProps>> = ({ theme, name }) => {
  const Icon = getAmenityIcon(theme);

  if (Icon) {
    return (
      <div className={cx(style['item'], style['with-icon'])}>
        <span aria-hidden="true" className={style['icon']}>
          <Icon color="icon-secondary-default" display="block" />
        </span>
        <UIText1>{name}</UIText1>
      </div>
    );
  }

  return (
    <div className={cx(style['item'], theme && style[theme])}>
      <UIText1>{name}</UIText1>
    </div>
  );
};
